import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { B11PaymentTypeManagementPage } from '../b11-payment-type-management/b11-payment-type-management';
import { B11dPaymentTypeSubListAddPage } from '../b11d-payment-type-sub-list-add/b11d-payment-type-sub-list-add';
import { B11ePaymentTypeSubListInfoPage } from '../b11e-payment-type-sub-list-info/b11e-payment-type-sub-list-info';
import { ServiceApiProvider } from '../../providers/service-api/service-api';

/**
 * Generated class for the B11cPaymentTypeSubListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface paymentSubTypeInfo {
	PAYMENT_SUB_TYPE_ID: number;
	SUB_TYPE: string;
	PAYMENT_TYPE_ID: number;
	PAYMENT_SUB_TYPE_ACTIVE: string;
}

@IonicPage()
@Component({
	selector: 'page-b11c-payment-type-sub-list',
	templateUrl: 'b11c-payment-type-sub-list.html',
})
export class B11cPaymentTypeSubListPage {
	
	loading: any;
	Status: any;
	public errorMessage: any = "";
	
	PAYMENT_TYPE_ID:any;
	paymentSubTypeArr: paymentSubTypeInfo[] = [];
	paymentSubTypeItems: paymentSubTypeInfo[] = [];

	constructor(public navCtrl: NavController, public navParams: NavParams,
				public serviceapi: ServiceApiProvider, public loadingCtrl: LoadingController) {
		this.PAYMENT_TYPE_ID = this.navParams.get('paramID');
		//console.log(this.PAYMENT_TYPE_ID);
		
		let tbl = ["PAYMENT_SUB_TYPE"];
		let column = ["PAYMENT_TYPE_ID"];
		let value = [this.PAYMENT_TYPE_ID];
		
		let tblkey = ["PAYMENT_TYPE_ID"];
		let fktbl = ["PAYMENT_TYPE"];
		let fkkey = ["PAYMENT_TYPE_ID"];
		
		let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
		let mydata = Object.assign(jsonitem);
		let json_data = this.serviceapi.json_readdata(mydata,"1");
		this.showLoader();

		this.serviceapi.readdata(json_data,"PAYMENT_SUB_TYPE","1","1").then((result) => {			
			this.Status = result["Message"];
			if (this.Status == '1') {
				this.loading.dismiss();				
				let Records = result["Records"];
				this.paymentSubTypeArr = Records;
				this.paymentSubTypeItems = this.paymentSubTypeArr;
				//console.log(this.paymentSubTypeItems);
			}
			else {
				this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
				this.loading.dismiss();
			}
		}, (err) => {
			this.errorMessage = "Loading Error. Please try again.";
			this.loading.dismiss();
		});
		
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad B11cPaymentTypeSubListPage');
	}
	
	goTo() {
		this.navCtrl.setRoot(B11PaymentTypeManagementPage);
	}
	
	goToAddPaymentSubType(PAYMENT_TYPE_ID) {
		this.navCtrl.push(B11dPaymentTypeSubListAddPage, {paramPaymentId: PAYMENT_TYPE_ID});
	}
	
	editPaymentSubType(PAYMENT_SUB_TYPE_ID) {
		this.navCtrl.push(B11ePaymentTypeSubListInfoPage, {paramSubPaymentId: PAYMENT_SUB_TYPE_ID});
	}
	
	showLoader() {
		this.loading = this.loadingCtrl.create({
			content: 'Loading...',
		});
		this.loading.present();
	}
}



// WEBPACK FOOTER //
// ./src/pages/b11c-payment-type-sub-list/b11c-payment-type-sub-list.ts